import React, { useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import Card from 'components/DesignSystem/Card';
import Selector from 'components/DesignSystem/Selector';
import EditButton from 'components/Shared/EditButton';
import RichHtml from 'components/RichHtml';
import SubtitleSemiBold from 'components/Typography/SubtitleSemiBold';

import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import useMensalSecaoParams from 'hooks/Relatorios/Mensal/useMensalSecaoParams';
import { useGetMensalSimilaridadeClimaticaQuery } from 'services/api/products/relatorios';
import OniChart from './OniChart';
import ComparativoChart from './ComparativoChart';

import './index.scss';

const SUBSISTEMA_PADRAO = 'SE/CO';

/**
 * Seção nova (sem precedente nos outros informes): ONI (anos análogos, ver
 * OniChart) + gráfico comparativo por subsistema. Mesmo layout de 2 colunas
 * (TEXTO + conteúdo) do ChuvaLayout variant="intersemanal", mas com 2
 * gráficos empilhados no lugar da galeria de mapas.
 */
export default function SimilaridadeClimatica() {
  const userIsAdmin = useSelector(selectUserIsAdmin);
  const params = useMensalSecaoParams();
  const [subsistema, setSubsistema] = useState(SUBSISTEMA_PADRAO);

  const { data, isLoading } = useGetMensalSimilaridadeClimaticaQuery({ ...params, subsistema });

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const { oni, comparativo } = data;

  return (
    <Row className="g-3">
      <Col md={5}>
        <Card
          className="h-100"
          title="TEXTO"
          actions={userIsAdmin && (
            <EditButton id="edit-similaridade-climatica" onClick={() => undefined} />
          )}
        >
          <RichHtml html={data.texto_html} className="w-100 ql-editor" />
        </Card>
      </Col>
      <Col md={7}>
        <Card className="h-100" title="SIMILARIDADE CLIMÁTICA">
          <SubtitleSemiBold>Variação Temporal do Niño 3.4 (ONI) (Anos Similares)</SubtitleSemiBold>
          <OniChart data={oni} />

          <div className="similaridade-climatica__comparativo-header">
            <SubtitleSemiBold>{comparativo.titulo}</SubtitleSemiBold>
            <Selector
              label="Subsistema"
              containerClassName="similaridade-climatica__selector"
              value={subsistema}
              setValue={setSubsistema}
            >
              {comparativo.subsistemas.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </Selector>
          </div>
          <ComparativoChart data={comparativo} />
        </Card>
      </Col>
    </Row>
  );
}
